export default "__VITE_ASSET__DEZthtGs__"